import script from "./contrast-color-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./contrast-color-text.vue?vue&type=script&setup=true&lang=ts"

import "./contrast-color-text.vue?vue&type=style&index=0&id=65312c8f&lang=css"

const __exports__ = script;

export default __exports__